import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'

/*
 * ===============
 * AUTH
 * ===============
 */
export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
  }),
  ...mapGetters('auth', ['loggedIn']),
}
export const authMethods = mapActions('auth', ['logIn', 'logOut', 'validate', 'register'])

/*
 * ===============
 * PROPERTY
 * ===============
 */
export const propertyComputed = {
  ...mapState('property', {
    property: (state) => state.currentProperty,
  }),
  ...mapGetters('property', [
    'currency',
    'memberDiscount',
    'useDecimal',
    'showFees',
  ]),
}

/*
 * ===============
 * CART
 * ===============
 */
export const cartComputed = {
  ...mapState('cart', ['checkIn', 'checkOut', 'promoCode', 'rooms', 'extras']),
  ...mapGetters('cart', [
    'los',
    'cartRoomsIsEmpty',
    'cartExtrasIsEmpty',
    'getRoomFromCart',
    'getRoomIndexFromCart',
    'totalRoomInCart',
    'cartRooms',
    'getExtraFromCart',
    'cartExtras',
    'cartDetails',
  ]),
}

export const sojernComputed = {
  ...mapState('cart', ['checkIn', 'checkOut', 'promoCode']),
  ...mapGetters('cart', ['los', 'cartRooms']),
}

export const cartMethods = {
  ...mapActions('cart', ['updateRoomCart', 'updateExtraCart']),
  ...mapMutations('cart', {
    setDate: 'SET_DATE',
    clearCart: 'CLEAR_CART',
  }),
}

/*
 * ===============
 * ROOMS
 * ===============
 */
export const roomsComputed = {
  ...mapState('rooms', {
    rooms: (state) => state.all,
  }),
}
export const roomsMethods = {
  ...mapActions('rooms', ['fetchRooms']),
}

/*
 * ===============
 * EXTRAS
 * ===============
 */
export const extrasComputed = {
  ...mapState('extras', {
    extras: (state) => state.all,
  }),
}

/*
 * ===============
 * APP
 * ===============
 */
export const appComputed = {
  ...mapState('app', ['searching', 'showCartDetails', 'alert']),
}
export const appMethods = {
  ...mapMutations('app', {
    beginSearching: 'BEGIN_SEARCHING',
    endSearching: 'END_SEARCHING',
    showCart: 'SHOW_CART',
    hideCart: 'HIDE_CART',
    showAlert: 'SET_ALERT',
  }),
}
